module.exports = __webpack_public_path__ + "img/btn-border-blue-hover.92b9a05.svg";